<template>
<div class='serviceMaintain'>
  <img src="~@/assets/image/common/common_maintain.png" alt="">
  <div>系统维护中，请稍后再进行查看</div>
</div>
</template>

<script>
  export default {
  name: 'serviceMaintain',
  };
</script>

<style scoped lang='less'>
.serviceMaintain{
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
    width: 2.773333rem;
  }
  div{
    font-size: 0.4rem;
    margin-top: 0.666667rem;
    color: #B9BED1;
  }
}
</style>
